exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-37073fe9] .el-dialog {\n  width: 5.208333rem;\n}\nvideo[data-v-37073fe9] {\n  display: block;\n  margin: 0.104167rem auto;\n  max-width: 90%;\n}", ""]);

// exports
